import axios from 'axios';
import store from "@/state/store";


const getDefaultState = () => {
    return {
        currentUser: {
            id: null,
            name: '',
            lastname: '',
            job_title: '',
            email: '',
            token: '',
            role: {}
        },
        permissions: [],
        interfaces: [],
        clients: [],
        selectedClient: {},
        clientCount: 0,
        supplierInfo: null
    }
}

export const state = getDefaultState();

export const getters = {
    // Whether the user is currently logged in.
    loggedIn(state) {
        return !!state.currentUser.id
    },
    clientCount(state) {
        return state.clients.length
    },
}

export const actions = {
    init({ dispatch }) {
        dispatch('validate')
    },
    validate({ commit, state }) {
        if (!state.currentUser) return Promise.resolve(null)
        const user = getAuthenticatedUser();
        commit('SET_CURRENT_USER', user)
        return user;
    },
    async logIn({ commit, dispatch, getters }, { email, password, token } = {}) {
        if (getters.loggedIn) return dispatch('validate')

        // API Request
        const response = await axios.post('users/login', { email, password, token })
            .catch(function (error) {
                if (error.response) return error.response
            })

        // Save user data
        if (response.data.access_token) {
            const userInfo = response.data;
            const user = {
                id: userInfo.user.id,
                name: userInfo.user.name,
                lastname: userInfo.user.lastname,
                job_title: userInfo.user.job_title,
                email: userInfo.user.email,
                token: userInfo.access_token,
                role: userInfo.user.role
            }

            // setLoggedInUser(user);
            commit('SET_CURRENT_USER', user);
            commit('SET_PERMISSIONS', userInfo.permissions);
            commit('SET_INTERFACES', userInfo.interfaces);
            commit('SET_SELECTED_CLIENT', userInfo.default_client);
            commit('SET_CLIENT_COUNT', userInfo.supplier_count);
            localStorage.setItem('activeInterface', userInfo.default_interface);
            return true;
        }

        return false;
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async logOut({ commit }) {
        // eslint-disable-next-line no-unused-vars
        // const user = getAuthenticatedUser();
        await axios.get('users/logout')
            .catch(function (error) {
                if (error.response) return error.response
            })
    },
    async clearAuthState({ commit }){
        commit('SET_CURRENT_USER', getDefaultState().currentUser);
        commit('SET_PERMISSIONS', getDefaultState().permissions);
        commit('SET_INTERFACES', getDefaultState().interfaces);
        commit('SET_CLIENTS', getDefaultState().clients);
        commit('SET_CLIENT_COUNT', getDefaultState().clientCount);
        commit('SET_SELECTED_CLIENT', getDefaultState().selectedClient);
        localStorage.removeItem('activeInterface');
    },
    async updateProfile({ commit, state }, userData) {
        await axios.put(`users/updateProfile`, userData);

        const token = JSON.parse(localStorage.getItem('authUser')).token;

        const user = {
            id: userData.id,
            name: userData.name,
            lastname: userData.lastname,
            job_title: userData.job_title,
            email: userData.email,
            token: token,
            role: state.currentUser.role
        }

        commit('SET_CURRENT_USER', user);
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async updatePassword({ commit }, userData) {
        await axios.put(`users/credentials`, userData);
        store.commit('auth/SET_CURRENT_USER', null);
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async forgotPassword({ commit }, email) {
        await axios.post(`users/forgotPassword`, {email: email});
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async resetPassword({ commit }, userData) {
        await axios.post(`users/resetPassword`, userData);
    },
    async fetchClients({ commit }) {
        const response = await axios.post('users/clients',{});
        commit('SET_CLIENTS', response.data.data)
        commit('SET_CLIENT_COUNT', response.data.data.length)
    },
    async setSelectedClient({ commit }, selectedClient) {
        await axios.post(`users/setClient`,{client_id: selectedClient.id});
        commit('SET_SELECTED_CLIENT', selectedClient);
    },
    async getSupplierInfo({ commit }) {
        const response = await axios.post(`suppliers/info`, { supplierValidation: true });
        commit('SET_SUPPLIER_INFO', response.data);
    }

}

export const mutations = {
    SET_CURRENT_USER(state, user) {
        state.currentUser = user === null ? getDefaultState().currentUser : user
    },
    SET_PERMISSIONS(state, permissions) {
        state.permissions = permissions;
    },
    SET_INTERFACES(state, interfaces) {
        state.interfaces = interfaces;
    },
    SET_CLIENTS(state, clients) {
        state.clients = clients;
    },
    SET_CLIENT_COUNT(state, clientCount) {
        state.clientCount = clientCount;
    },
    SET_SELECTED_CLIENT(state, selectedClient) {
        state.selectedClient = selectedClient;
    },
    SET_SUPPLIER_INFO(state, supplierInfo) {
        state.supplierInfo = supplierInfo;
    },
    test(state) {
        console.log(state.currentUser)
    },
}

// ===
// Private helpers
// ===

// function saveState(key, state) {
//     if (state) {
//         localStorage.setItem(key, JSON.stringify(state));
//     } else {
//         localStorage.removeItem(key);
//     }
// }


/**
 * Returns the authenticated user
 */
function getAuthenticatedUser() {
    if (!localStorage.getItem('authUser'))
        return null;
    return JSON.parse(localStorage.getItem('authUser'));
}